<template>
  <div class="flex items-center justify-center bg-slate-50 p-5">
    <slot />
  </div>
</template>
